export const convertDataToTimezonedData = (data, formatter) => {
    return data.map((item) => {
        if ('day' in item && typeof item.day === 'string') {
            return {
                ...item,
                day: formatter(item.day),
            };
        }
        return item;
    });
};
